import { KTSVG } from "../../../../../../../../_metronic/helpers"
import { downloadXLSFile, array_fill_keys } from "../../../../../../../components/helpers";
import { useDOCLabelFormView } from "./DOCLabelFormContextProvider";

const FILE_COLUMNS = [
  'Site No',
  'Project Name',
  'Project Location',
  'Installer Company',
  'SCDF Building Plan No',
  'Client Ref No',
  'Other Reference Number (DSTA Number)',
  'Size W x H (mm) / Model',
  'Quantity',
  'Remarks',
];

const DOORFILE_COLUMNS = [
  'Site No',
  'Project Name',
  'Project Location',
  'Installer Company',
  'SCDF Building Plan No',
  'Client Ref No',
  'Other Reference Number (DSTA Number)',
  'Size W x H (mm) / Model (F)',
  'Size W x H (mm) / Model (L)',
  'Quantity',
  'Leaf Type (EDL/UDL/SL)',
  'Vision Panel (Y/N)',
  'Remarks',
];

export const DOCLabelDownloadTemplateButton = () => {

  const { isDoor } = useDOCLabelFormView();

  const downloadTemplate = () => {    

    let columns = isDoor ? DOORFILE_COLUMNS : FILE_COLUMNS;
    let blank_row = array_fill_keys(columns, '');
    
    downloadXLSFile(
      [blank_row], 
      columns,       
      isDoor ? 'Import_Template_Door' : 'Import_Template',
      'Sheet1'
    );
  }

  return (
    <button type='button' className='btn btn-sm btn-light-secondary fs-7' onClick={downloadTemplate} >
      <KTSVG path='/media/icons/duotune/arrows/arr091.svg' className='svg-icon-2'  />
      Download Template
    </button>
  )
}